export function parsePrice(value: string | null | undefined): number {
  if (value == null || value === '') return 0;
  const n = parseFloat(value);
  return isFinite(n) ? n : 0;
}
